/**
 * Initializer that triggers jQuery event on target element.
 * If data-target is not present, current element is used as target.
 *
 * Usage:
 * <span data-trigger="my.event.name" data-target="#targetElementId"></span>
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var el = this;
    (0, _jquery2.default)('[data-trigger]', el).each(function () {
        var $this = (0, _jquery2.default)(this);
        var eventName = $this.attr('data-trigger');
        var $target = (0, _jquery2.default)($this.attr('data-target'));
        if ($target.length === 0) {
            $target = $this;
        }
        $target.trigger(eventName);
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/trigger.js
// module id = 1137
// module chunks = 1